import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { type FC, type ReactNode } from "react";
import { useDialog } from "../../../../../../utils/hooks/use-dialog";
import { ChannelIcon } from "../../../../../channels/components/channel-icon";
import type { ChannelName } from "../../../../../channels/types";
import { prettyChannelName } from "../../../../../channels/utils";

type Props = {
  persons: number;
  channel: ChannelName;
  buttonText: string;
  children: ReactNode;
};

export const PreviewPersonsButton: FC<Props> = ({ persons, buttonText, channel, children }) => {
  const dialog = useDialog();

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        data-analytics-id="people-in-segment-channel-button"
        sx={{ color: (theme) => theme.palette[persons === 0 ? "error" : "primary"].main }}
      >
        <Link
          component="button"
          type="button"
          color="inherit"
          underline="hover"
          variant="body2"
          disabled={persons === 0}
          onClick={() => dialog.handleOpen("persons")}
          sx={{ fontWeight: "400" }}
        >
          {buttonText}
        </Link>
        <Stack direction="row" alignItems="center" spacing={0.25}>
          <ChannelIcon channel={channel} fontSize="small" />
          <Typography variant="body2" color="inherit">
            {persons}
          </Typography>
        </Stack>
      </Stack>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        <DialogTitle>People in Segment Group for {prettyChannelName(channel)}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={dialog.handleClose} data-analytics-id="people-in-segment-close-button">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
